import track from 'react-tracking';
import { useWatchlist } from '@/hooks/useWatchlist';

import useWatchlistMutations from '../../hooks/useWatchlistMutations';

import Search from './Search';
import { Wrapper } from './styled';

const Empty = () => {
  const { status } = useWatchlist();
  const { addCompanyStatus } = useWatchlistMutations();
  return (
    <Wrapper>
      {addCompanyStatus === 'error' && (
        <>
          <h3 data-cy-id="empty-state-error">Something went wrong!</h3>
          <p>We're sorry, but an error occured. Please try again later.</p>
        </>
      )}
      {status === 'success' && addCompanyStatus === 'idle' && (
        <>
          <h3 data-cy-id="empty-state">No companies in your watchlist yet!</h3>
          <p>
            Add companies to track performance, important announcements and
            fundamental changes
          </p>
          <Search />
        </>
      )}
    </Wrapper>
  );
};

export default track({
  type: 'track',
  subject: 'emptyState',
})(Empty) as typeof Empty;
